import React, { useState, useEffect } from "react";
import {
  fetchPermissions,
  getPermissionById,
  addPermission,
  updatePermission,
  deletePermission,
} from "../../../actions/permissionAction";
import { connect } from "react-redux";
import FormPermission from "./FormPermission";
import { sortHelper } from "../../../utils/helpers/sortHelper";
import { AlertConfirmModal } from "../../../components/Modals/AlertConfirmModal";
import { OPTION_TYPE_ACCESS } from "../../../helpers/config";

const PermissionPage = (props) => {
  const {
    permission: _permission,
    permissions,
    isLoading,
    fetchPermissions,
    getPermissionById: _getPermissionById,
    addPermission,
    updatePermission,
    deletePermission,
  } = props;
  const [perPage, setPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const { sortConfig, handleSort, getSortedData } = sortHelper.useSort();

  const handlePerPageChange = (value) => {
    setPerPage(value);
    setCurrentPage(1);
  };

  const initialState = {
    id: "",
    name: "",
    type: "",
    slug: "",
  };

  const [isShowModal, setIsShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [items, setItems] = useState(permissions || []);
  const [formState, setFormState] = useState(initialState);

  const totalPages = Math.ceil(items?.length / perPage);
  const paginatedItems = items?.slice((currentPage - 1) * perPage, currentPage * perPage);
  const openModal = () => {
    setFormState(initialState);
    setIsShowModal(true);
  };
  const closeModal = () => {
    setFormState(initialState);
    setIsShowModal(false);
    setIsEdit(false);
  };
  const closeModalDelete = () => {
    setFormState(initialState);
  };
  const handleDelete = () => {
    deletePermission(formState?.id);
  };
  const handleAdd = async () => {
    const success = await addPermission(formState);
    if (success) closeModal();
    return success;
  };
  const handleUpdate = async () => {
    const success = await updatePermission(formState?.id, formState);
    if (success) closeModal();
    return success;
  };
  useEffect(() => {
    fetchPermissions();
  }, [fetchPermissions]);
  useEffect(() => {
    if (permissions) {
      const filteredItems = permissions?.filter((item) => {
        const isTextMatch =
          item?.username?.toLowerCase()?.includes(filterText?.toLowerCase()) ||
          item?.name?.toLowerCase()?.includes(filterText?.toLowerCase());

        return isTextMatch;
      });
      setItems(filteredItems);
    }
  }, [permissions, filterText]);

  return (
    <div className="page-wrapper">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h1 className="page-title fs-1 text-capitalize">Data Permission</h1>
              <div className="page-pretitle">master permission</div>
            </div>
            <div className="col-auto ms-auto d-print-none">
              <div className="btn-list">
                <button
                  type="button"
                  className="btn btn-primary btn-5 d-none d-sm-inline-block"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-form"
                  onClick={openModal}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-2">
                    <path d="M12 5l0 14" />
                    <path d="M5 12l14 0" />
                  </svg>
                  Tambah Permission
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-6 d-sm-none btn-icon"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-form"
                  onClick={openModal}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-2">
                    <path d="M12 5l0 14" />
                    <path d="M5 12l14 0" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="row row-deck row-cards">
            <div className="col-12">
              <div className="card">
                <div className="card-table">
                  <div className="card-header ">
                    <div className="row w-full">
                      <div className="col-md-9 col-12">
                        <h3 className="card-title mb-0">Permission</h3>
                        <p className="text-secondary m-0">Master Permission</p>
                      </div>
                      <div className="col-md-3 col-12 my-md-0 my-2">
                        <div className="input-group input-group-flat w-auto">
                          <span className="input-group-text">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-1">
                              <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                              <path d="M21 21l-6 -6" />
                            </svg>
                          </span>
                          <input
                            id="advanced-table-search"
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={(e) => {
                              setFilterText(e.target.value);
                            }}
                            placeholder="Cari..."
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="advanced-table">
                    <div className="table-responsive">
                      <table className="table table-vcenter table-selectable">
                        <thead className="table-header">
                          <tr>
                            <th className="sort-name py-3 fw-bold w-1">No.</th>
                            <sortHelper.SortableHeader
                              label="Nama Akses"
                              sortKey="name"
                              sortConfig={sortConfig}
                              onSort={handleSort}
                            />

                            <sortHelper.SortableHeader
                              label="Tipe Akses"
                              sortKey="type"
                              sortConfig={sortConfig}
                              onSort={handleSort}
                            />

                            <th className="sort-status fw-bold">Slug</th>
                            <th className="sort-status fw-bold">Status</th>
                            <th></th>
                          </tr>
                        </thead>

                        <tbody className="table-tbody">
                          {isLoading
                            ? [...Array(paginatedItems?.length || 5)]?.map((_, index) => (
                                <tr
                                  key={`loading-${index}`}
                                  style={{
                                    cursor: "loader",
                                  }}>
                                  <td className="sort-name py-3">{(currentPage - 1) * perPage + index + 1}.</td>
                                  {[...Array(3)].map((_, i) => (
                                    <td key={i}>
                                      <div className="placeholder placeholder-lg w-75"></div>
                                    </td>
                                  ))}
                                  <td>
                                    <div className="placeholder placeholder-lg w-100"></div>
                                  </td>
                                  <td
                                    className="justify-content-start text-start flex-nowrap"
                                    style={{
                                      width: "10%",
                                    }}>
                                    <div
                                      className="placeholder placeholder-lg me-2 "
                                      style={{
                                        width: "40%",
                                      }}></div>
                                    <div
                                      className="placeholder placeholder-lg "
                                      style={{
                                        width: "40%",
                                      }}></div>
                                  </td>
                                </tr>
                              ))
                            : getSortedData(paginatedItems)?.map((permission, index) => (
                                <tr key={permission?.id}>
                                  <td className="sort-name">{(currentPage - 1) * perPage + index + 1}.</td>
                                  <td className="sort-city">{permission?.name}</td>
                                  <td className="sort-status">
                                    <span
                                      className={`badge fw-bold ${OPTION_TYPE_ACCESS.find((item) => item.value === permission?.type)?.color}`}>
                                      {permission?.type}
                                    </span>
                                  </td>
                                  <td className="sort-status">
                                    <span
                                      className={`badge fw-bold ${OPTION_TYPE_ACCESS.find((item) => item.value === permission?.type)?.color}`}>
                                      {permission?.slug}
                                    </span>
                                  </td>
                                  <td className="sort-status">
                                    <span className="badge bg-success-lt">Active</span>
                                  </td>
                                  <td>
                                    <div className="btn-list flex-nowrap justify-content-center">
                                      <button
                                        type="button"
                                        className="btn btn-1 bg-secondary-lt"
                                        data-bs-toggle="modal"
                                        data-bs-target="#modal-form"
                                        aria-label={`Edit izin ${permission?.name || ""}`.trim()}
                                        onClick={() => {
                                          setIsEdit(true);
                                          setFormState({
                                            id: permission?.id,
                                            name: permission?.name,
                                            type: permission?.type,
                                            slug: permission?.slug,
                                          });
                                          setIsShowModal(true);
                                        }}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-edit">
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                                          <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                                          <path d="M16 5l3 3" />
                                        </svg>{" "}
                                        Edit{" "}
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-1 bg-danger-lt"
                                        data-bs-toggle="modal"
                                        data-bs-target="#modal-alert"
                                        aria-label={`Hapus izin ${permission?.name || ""}`.trim()}
                                        onClick={() => {
                                          setFormState({
                                            id: permission?.id,
                                            name: permission?.name,
                                          });
                                        }}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-trash">
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M4 7l16 0" />
                                          <path d="M10 11l0 6" />
                                          <path d="M14 11l0 6" />
                                          <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                          <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                                        </svg>{" "}
                                        Hapus
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="card-footer d-flex align-items-center">
                      <div className="dropdown">
                        <button className="btn dropdown-toggle" data-bs-toggle="dropdown">
                          <span id="page-count" className="me-1">
                            {perPage}
                          </span>
                          <span>records</span>
                        </button>
                        <div className="dropdown-menu">
                          {[10, 20, 50, 100]?.map((value) => (
                            <button key={value} className="dropdown-item" onClick={() => handlePerPageChange(value)}>
                              {value} records
                            </button>
                          ))}
                        </div>
                      </div>

                      <ul className="pagination m-0 ms-auto">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>
                            <svg width="24" height="24" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                              <path d="M15 6l-6 6l6 6" />
                            </svg>
                          </button>
                        </li>

                        {[...Array(totalPages)]?.map((_, idx) => {
                          const page = idx + 1;
                          return (
                            <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                              <button className="page-link" onClick={() => setCurrentPage(page)}>
                                {page}
                              </button>
                            </li>
                          );
                        })}

                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}>
                            <svg width="24" height="24" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                              <path d="M9 6l6 6l-6 6" />
                            </svg>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormPermission
        isShowModal={isShowModal}
        isEdit={isEdit}
        closeModal={closeModal}
        formState={formState}
        setFormState={setFormState}
        handleAdd={handleAdd}
        handleUpdate={handleUpdate}
      />

      <AlertConfirmModal
        type="error"
        message={`Menghapus data ${formState?.name}`}
        confirmText="Hapus"
        cancelText="Batal"
        idModal="alert"
        idData={formState?.id}
        onConfirm={(id, reason) => {
          handleDelete(id, reason);
        }}
        onCancel={() => {
          closeModalDelete();
        }}
      />

      {/* <ModalDelete
         labelModal={formState?.name}
         isShowModal={isShowModalDelete}
         closeModal={closeModalDelete}
         handleDelete={handleDelete}
        /> */}
      {/* <OverlayLoading isShow={isLoading} /> */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  permission: state?.permissions?.data,
  permissions: state?.permissions?.datas,
  isLoading: state?.permissions?.loading,
});

export default connect(mapStateToProps, {
  fetchPermissions,
  getPermissionById,
  addPermission,
  updatePermission,
  deletePermission,
})(PermissionPage);
